import { render } from "./InventoryList.vue?vue&type=template&id=7f0ad042&scoped=true"
import script from "./InventoryList.vue?vue&type=script&lang=js"
export * from "./InventoryList.vue?vue&type=script&lang=js"

import "./InventoryList.vue?vue&type=style&index=0&id=7f0ad042&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0ad042"],['__file',"src/views/h5/common/stock/inventory/InventoryList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f0ad042"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f0ad042', __exports__)) {
    api.reload('7f0ad042', __exports__)
  }
  
  module.hot.accept("./InventoryList.vue?vue&type=template&id=7f0ad042&scoped=true", () => {
    api.rerender('7f0ad042', render)
  })

}


export default __exports__